import { Link } from "react-router";
import { styled } from "styled-components";

import { RightArrow } from "common/components/icons";
import { UIButton } from "common/components/UIButton";
import { useTranslate } from "common/utilities/useTranslate";

type SeeAllButtonProps = { className?: string; link: string; withoutText?: boolean };

const StyledArrow = styled(RightArrow)`
  width: 14px;
  height: 14px;
  margin-left: 0.5rem;
`;

const StyledLink = styled(Link)`
  text-decoration: none;
  display: block;
`;

const StyledUIButton = styled(UIButton)`
  padding: 0;
  width: 40px;

  svg {
    margin-left: 0;
  }
`;

export const SeeAllButton = ({ className, link, withoutText = false }: SeeAllButtonProps) => {
  const translate = useTranslate();

  return (
    <StyledLink to={link}>
      {withoutText ? (
        <StyledUIButton variant="neutral" className={className}>
          <StyledArrow />
        </StyledUIButton>
      ) : (
        <UIButton variant="neutral" className={className}>
          {translate("app.topic.see_all")}
          <StyledArrow />
        </UIButton>
      )}
    </StyledLink>
  );
};
